export const SET_ID = (state, value) => {
  state.id = value
}

export const SET_USERNAME = (state, value) => {
  state.username = value
}

export const SET_PASSWORD = (state, value) => {
  state.password = value
}

export const SET_EMAIL = (state, value) => {
  state.email = value
}

export const SET_ROLE = (state, value) => {
  state.role = value
}
